export const productCategories = [
  {
    id: 'vapes',
    name: 'Vapes & Disposables',
    description: 'Premium vaping devices and disposables',
    image: 'https://public.readdy.ai/ai/img_res/c12c06512af6c55b8ff249962d821a74.jpg',
    itemCount: 45
  },
  {
    id: 'glass',
    name: 'Premium Glass',
    description: 'Hand-crafted glass pieces and bongs',
    image: 'https://readdy.ai/api/search-image?query=luxury%20artistic%20glass%20bong%20water%20pipe%20premium%20handcrafted%20borosilicate%20on%20dark%20elegant%20minimalist%20background%20with%20dramatic%20lighting%20studio%20product%20photography%20sophisticated%20clean%20simple%20backdrop%20high%20end%20commercial%20style&width=600&height=600&seq=glass-cat-002&orientation=squarish',
    itemCount: 38
  },
  {
    id: 'hookah',
    name: 'Hookah & Shisha',
    description: 'Traditional and modern hookah setups',
    image: 'https://readdy.ai/api/search-image?query=elegant%20modern%20hookah%20shisha%20pipe%20premium%20luxury%20design%20on%20dark%20sophisticated%20minimalist%20background%20with%20ambient%20lighting%20studio%20product%20photography%20high%20end%20clean%20simple%20backdrop%20professional%20commercial%20style&width=600&height=600&seq=hookah-cat-003&orientation=squarish',
    itemCount: 32
  },
  {
    id: 'accessories',
    name: 'Accessories',
    description: 'Curated smoking accessories',
    image: 'https://readdy.ai/api/search-image?query=premium%20smoking%20accessories%20collection%20luxury%20grinder%20lighter%20rolling%20papers%20on%20dark%20elegant%20minimalist%20background%20with%20soft%20lighting%20studio%20product%20photography%20sophisticated%20clean%20simple%20backdrop%20high%20end%20commercial%20style&width=600&height=600&seq=accessories-cat-004&orientation=squarish',
    itemCount: 56
  }
];

export const featuredProducts = [
  {
    id: 1,
    name: 'Elite Vape Pro X',
    category: 'Vapes & Disposables',
    price: 49.99,
    image: 'https://readdy.ai/api/search-image?query=sleek%20modern%20premium%20vape%20device%20metallic%20finish%20luxury%20electronic%20cigarette%20on%20dark%20elegant%20minimalist%20background%20with%20dramatic%20studio%20lighting%20high%20end%20product%20photography%20sophisticated%20clean%20simple%20backdrop%20professional%20commercial%20style&width=400&height=400&seq=prod-vape-001&orientation=squarish',
    description: 'Advanced vaping technology with premium flavor delivery'
  },
  {
    id: 2,
    name: 'Crystal Clear Beaker',
    category: 'Premium Glass',
    price: 129.99,
    image: 'https://readdy.ai/api/search-image?query=crystal%20clear%20glass%20beaker%20bong%20water%20pipe%20premium%20borosilicate%20artistic%20craftsmanship%20on%20dark%20elegant%20minimalist%20background%20with%20soft%20studio%20lighting%20high%20end%20product%20photography%20sophisticated%20clean%20simple%20backdrop%20professional%20commercial%20style&width=400&height=400&seq=prod-glass-002&orientation=squarish',
    description: 'Hand-blown borosilicate glass with ice catcher'
  },
  {
    id: 3,
    name: 'Royal Hookah Set',
    category: 'Hookah & Shisha',
    price: 189.99,
    image: 'https://readdy.ai/api/search-image?query=luxury%20traditional%20hookah%20set%20ornate%20design%20premium%20brass%20and%20glass%20construction%20on%20dark%20elegant%20minimalist%20background%20with%20ambient%20studio%20lighting%20high%20end%20product%20photography%20sophisticated%20clean%20simple%20backdrop%20professional%20commercial%20style&width=400&height=400&seq=prod-hookah-003&orientation=squarish',
    description: 'Complete hookah setup with premium hose and bowl'
  },
  {
    id: 4,
    name: 'Diamond Grinder',
    category: 'Accessories',
    price: 34.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20metal%20herb%20grinder%20diamond%20cut%20pattern%20luxury%20aluminum%20construction%20on%20dark%20elegant%20minimalist%20background%20with%20soft%20studio%20lighting%20high%20end%20product%20photography%20sophisticated%20clean%20simple%20backdrop%20professional%20commercial%20style&width=400&height=400&seq=prod-acc-004&orientation=squarish',
    description: 'Precision-cut aluminum grinder with magnetic closure'
  },
  {
    id: 5,
    name: 'Platinum Disposable',
    category: 'Vapes & Disposables',
    price: 24.99,
    image: 'https://readdy.ai/api/search-image?query=elegant%20disposable%20vape%20pen%20sleek%20metallic%20design%20premium%20compact%20device%20on%20dark%20elegant%20minimalist%20background%20with%20dramatic%20studio%20lighting%20high%20end%20product%20photography%20sophisticated%20clean%20simple%20backdrop%20professional%20commercial%20style&width=400&height=400&seq=prod-vape-005&orientation=squarish',
    description: '5000 puffs with premium flavor options'
  },
  {
    id: 6,
    name: 'Artisan Bubbler',
    category: 'Premium Glass',
    price: 89.99,
    image: 'https://readdy.ai/api/search-image?query=artistic%20glass%20bubbler%20pipe%20colorful%20swirls%20premium%20handcrafted%20borosilicate%20on%20dark%20elegant%20minimalist%20background%20with%20soft%20studio%20lighting%20high%20end%20product%20photography%20sophisticated%20clean%20simple%20backdrop%20professional%20commercial%20style&width=400&height=400&seq=prod-glass-006&orientation=squarish',
    description: 'Unique hand-crafted design with smooth filtration'
  },
  {
    id: 7,
    name: 'Premium Shisha Mix',
    category: 'Hookah & Shisha',
    price: 19.99,
    image: 'https://readdy.ai/api/search-image?query=luxury%20shisha%20tobacco%20packaging%20premium%20flavored%20hookah%20tobacco%20elegant%20container%20on%20dark%20elegant%20minimalist%20background%20with%20ambient%20studio%20lighting%20high%20end%20product%20photography%20sophisticated%20clean%20simple%20backdrop%20professional%20commercial%20style&width=400&height=400&seq=prod-shisha-007&orientation=squarish',
    description: 'Exotic flavor blend for smooth smoking experience'
  },
  {
    id: 8,
    name: 'Luxury Rolling Tray',
    category: 'Accessories',
    price: 44.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20metal%20rolling%20tray%20luxury%20design%20elegant%20surface%20with%20compartments%20on%20dark%20elegant%20minimalist%20background%20with%20soft%20studio%20lighting%20high%20end%20product%20photography%20sophisticated%20clean%20simple%20backdrop%20professional%20commercial%20style&width=400&height=400&seq=prod-acc-008&orientation=squarish',
    description: 'Magnetic lid with built-in storage compartments'
  },
  {
    id: 9,
    name: 'CBD Vape Cartridge',
    category: 'CBD Products',
    price: 39.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20cbd%20vape%20cartridge%20glass%20container%20luxury%20packaging%20high%20quality%20oil%20on%20dark%20elegant%20minimalist%20background%20with%20dramatic%20studio%20lighting%20high%20end%20product%20photography%20sophisticated%20clean%20simple%20backdrop%20professional%20commercial%20style&width=400&height=400&seq=prod-cbd-009&orientation=squarish',
    description: 'Pure CBD oil with natural terpenes'
  },
  {
    id: 10,
    name: 'Signature Glass Pipe',
    category: 'Premium Glass',
    price: 54.99,
    image: 'https://readdy.ai/api/search-image?query=elegant%20glass%20smoking%20pipe%20artistic%20design%20premium%20handcrafted%20borosilicate%20colorful%20patterns%20on%20dark%20elegant%20minimalist%20background%20with%20soft%20studio%20lighting%20high%20end%20product%20photography%20sophisticated%20clean%20simple%20backdrop%20professional%20commercial%20style&width=400&height=400&seq=prod-glass-010&orientation=squarish',
    description: 'Compact design with artistic color work'
  },
  {
    id: 11,
    name: 'Torch Lighter Set',
    category: 'Accessories',
    price: 29.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20torch%20lighter%20set%20luxury%20metal%20construction%20elegant%20design%20on%20dark%20elegant%20minimalist%20background%20with%20soft%20studio%20lighting%20high%20end%20product%20photography%20sophisticated%20clean%20simple%20backdrop%20professional%20commercial%20style&width=400&height=400&seq=prod-acc-011&orientation=squarish',
    description: 'Refillable torch with adjustable flame'
  },
  {
    id: 12,
    name: 'Modern Hookah Base',
    category: 'Hookah & Shisha',
    price: 149.99,
    image: 'https://readdy.ai/api/search-image?query=contemporary%20modern%20hookah%20base%20sleek%20design%20premium%20glass%20and%20metal%20construction%20on%20dark%20elegant%20minimalist%20background%20with%20ambient%20studio%20lighting%20high%20end%20product%20photography%20sophisticated%20clean%20simple%20backdrop%20professional%20commercial%20style&width=400&height=400&seq=prod-hookah-012&orientation=squarish',
    description: 'Contemporary design with LED lighting'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Marcus Johnson',
    rating: 5,
    text: 'Hands-down, the best vape shop in town And has the best prices. Always met with a friendly smile and great customer service. And always make me laugh. I will always come here to get my vape products. Thank you!',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20african%20american%20man%20smiling%20confident%20friendly%20expression%20on%20neutral%20soft%20background%20natural%20lighting%20headshot%20photography%20realistic%20style&width=100&height=100&seq=avatar-001&orientation=squarish'
  },
  {
    id: 2,
    name: 'Sarah Mitchell',
    rating: 5,
    text: 'Awesome shop! The owner is amazing!!! Second shop of his I\'ve been to and they keep getting better. Slushies are delicious, variety is awesome, and his dog Luna is so cute. Yes it\'s a small shop that you will miss if you\'re not looking for it, but it\'s definitely worth slowing down and stopping in. You will not regret it.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20caucasian%20woman%20smiling%20warm%20friendly%20expression%20on%20neutral%20soft%20background%20natural%20lighting%20headshot%20photography%20realistic%20style&width=100&height=100&seq=avatar-002&orientation=squarish'
  },
  {
    id: 3,
    name: 'David Chen',
    rating: 5,
    text: 'Love this shop! Owner is super friendly and knowledgeable about products. They always have what I need and they have such good quality items. Highly recommend going here!!',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20asian%20man%20smiling%20confident%20friendly%20expression%20on%20neutral%20soft%20background%20natural%20lighting%20headshot%20photography%20realistic%20style&width=100&height=100&seq=avatar-003&orientation=squarish'
  }
];

export const galleryImages = [
  {
    id: 1,
    url: 'https://static.readdy.ai/image/4f6582e073a5efa66fcf915170e338fb/4d5d172de8294abe64f8920e81037af9.jpeg',
    caption: 'Premium Glass Collection'
  },
  {
    id: 2,
    url: 'https://static.readdy.ai/image/4f6582e073a5efa66fcf915170e338fb/d20ab426c7ba9b402562dd8d1692ec7a.jpeg',
    caption: 'Vape Selection'
  },
  {
    id: 3,
    url: 'https://static.readdy.ai/image/4f6582e073a5efa66fcf915170e338fb/15668fa7ec9bb60dbc8459ac8e3b6600.jpeg',
    caption: 'Smoothies & Slushies'
  },
  {
    id: 4,
    url: 'https://static.readdy.ai/image/4f6582e073a5efa66fcf915170e338fb/ad574e7650216cb118a6593cf3cdeab7.jpeg',
    caption: 'Kratom'
  },
  {
    id: 5,
    url: 'https://static.readdy.ai/image/4f6582e073a5efa66fcf915170e338fb/cd636f0820153fa8e1cae0135d02e72a.jpeg',
    caption: 'Store Exterior'
  }
];
